// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/organization/OrganizationHistoryPanel.jsx

import React from "react";

function formatDate(value) {
  if (!value) return "Unknown time";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

function humanize(value) {
  return String(value || "organization event")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export default function OrganizationHistoryPanel({ history = [] }) {
  return (
    <section className="enterprise-admin-organization-history">
      <header>
        <div>
          <p className="enterprise-admin-eyebrow">Administrative history</p>
          <h3>Organization changes</h3>
          <p>Every saved update is preserved with actor, timestamp, and changed fields.</p>
        </div>
        <span>{history.length} events</span>
      </header>

      {history.length ? (
        <div className="enterprise-admin-organization-history-list">
          {history.map((event) => {
            const changedFields = event?.metadata?.updated_fields || [];
            return (
              <article key={event.id}>
                <div className="enterprise-admin-organization-history-marker" aria-hidden="true" />
                <div>
                  <strong>{humanize(event.action)}</strong>
                  <span>
                    {event.actor_name || "OASYS Administrator"} · {formatDate(event.created_at)}
                  </span>
                  {changedFields.length ? (
                    <p>{changedFields.map(humanize).join(", ")}</p>
                  ) : (
                    <p>Initial organization profile created.</p>
                  )}
                </div>
                <code>{event.correlation_id || event.id}</code>
              </article>
            );
          })}
        </div>
      ) : (
        <div className="enterprise-admin-empty">
          <strong>No organization history yet</strong>
          <p>The first saved organization change will appear here.</p>
        </div>
      )}
    </section>
  );
}
